module.exports = __webpack_public_path__ + "img/empty-tasks.b33b28e1.svg";